<!-- pindahin kondisi ini di parent -->
@if (data) {
    <div class="invoice__container">
        <img [src]="data.image" alt="" class="invoice__image">
        <div class="invoice__label">{{'invoiceClaim.' + status + '.label' | translate}}</div>
        <div class="invoice__description">{{'invoiceClaim.' + status + '.description' | translate}}</div>
        <button class="invoice__button">{{'invoiceClaim.' + status + '.buttonText' | translate}}</button>
        <div class="invoice__help__center">{{'invoiceClaim.' + status + '.helpCenter.text' | translate}} <a [href]="data.helpCenter.helpCenterUrl">{{'invoiceClaim.' + status + '.helpCenter.linkText' | translate}}</a></div>
    </div>
}
